import React, { useState } from "react";
import { Container, Box, Button, Dialog, DialogContent, Grid } from "@mui/material";
import ModalDialogTitle from "../../common/ModalDialogTitle";
import UserProfileRequest from "./inc/UserProfileRequest";
import DropStudentsRequest from "./inc/DropStudentsRequest";
import TestingRequest from "./inc/TestingRequests";
import CourseProctorApp from "./inc/CourseProctorApp";
import GradeReport from "./inc/GradeReport";
import RegReport from "./inc/RegReport";
import ChangeCourseRequests from "./inc/ChangeCourseRequests";
import NewCourseRequests from "./inc/NewCourseRequests";
import SchoolChangeForm from "./inc/SchoolChangeForm";
import ApplicationDay from "./inc/ApplicationDay";
import CcpAdminBreadCrumbs from "../../Layout/CcpAdminBreadCrumbs";
import { faBarChart } from "@fortawesome/free-solid-svg-icons";

const CcpAdminArchiveData = () => {
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedComponent, setSelectedComponent] = useState(null);
  const [dialogTitle, setDialogTitle] = useState("");

  const sources = [
    "UserProfileRequest",
    "DropStudentsRequest",
    "TestingRequest",
    "CourseProctorApp",
    "GradeReport",
    "RegReport",
    "ChangeCourseRequests",
    "NewCourseRequests",
    "SchoolChangeForm",
    "ApplicationDay",
  ];
  const pageName = "Archived Data";
  const icon = faBarChart;

  const handleOpenDialog = (component, title) => {
    setSelectedComponent(component);
    setDialogTitle(title);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedComponent(null);
    setDialogTitle("");
  };

  const buttonData = [
    {
      label: "User Profile Request",
      component: <UserProfileRequest source={sources[0]} />,
      color: "primary",
    },
    {
      label: "Drop Students Request",
      component: <DropStudentsRequest source={sources[1]} />,
      color: "secondary",
    },
    {
      label: "Placement Request",
      component: <TestingRequest source={sources[2]} />,
      color: "success",
    },
    {
      label: "Course Proctor App",
      component: <CourseProctorApp />,
      color: "warning",
    },
    {
      label: "Grade Report",
      component: <GradeReport source={sources[4]} />,
      color: "info",
    },
    {
      label: "Reg Report",
      component: <RegReport source={sources[5]} />,
      color: "error",
    },
    {
      label: "Change Course Requests",
      component: <ChangeCourseRequests source={sources[6]} />,
      color: "primary",
    },
    {
      label: "New Course Requests",
      component: <NewCourseRequests source={sources[7]} />,
      color: "secondary",
    },
    {
      label: "School Change Form",
      component: <SchoolChangeForm />,
      color: "success",
    },
    {
      label: "Application Day",
      component: <ApplicationDay source={sources[9]} />,
      color: "warning",
    },
  ];

  return (
    <Container sx={{ marginTop: "100px" }} maxWidth="xl">
      <CcpAdminBreadCrumbs pageName={pageName} icon={icon} />
      <Box sx={{ mt: 2 }}>
        <Grid container spacing={2}>
          {buttonData.map((item, index) => (
            <Grid item key={index}>
              <Button
                variant="contained"
                color={item.color}
                onClick={() => handleOpenDialog(item.component, item.label)}
              >
                {item.label}
              </Button>
            </Grid>
          ))}
        </Grid>
      </Box>

      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        maxWidth="xl"
        fullWidth
      >
        <ModalDialogTitle onClose={handleCloseDialog}>
          {dialogTitle}
        </ModalDialogTitle>
        <DialogContent>{selectedComponent}</DialogContent>
      </Dialog>
    </Container>
  );
};

export default CcpAdminArchiveData;
